import React from "react";

function MultiMillMachine() {
  return (
    <>
      <style>{`
      .technical-spec-section {
        margin: 40px 0;
        overflow-x: auto;
      }
      .technical-spec-section h4 {
        font-family: 'Oxygen', sans-serif;
        font-weight: bold;
        font-size: 24px;
        color: #000;
        margin-bottom: 20px;
      }
      .table {
        width: 100%;
        border-collapse: collapse;
        background: white;
      }
      .table-bordered {
        border: 1px solid #ddd;
      }
      .table-bordered td {
        border: 1px solid #ddd;
        padding: 12px 15px;
        font-size: 14px;
      }
      .table tbody tr:nth-child(even) {
        background-color: #f2f2f2;
      }
      .table td:first-child {
        font-weight: 600;
        width: 40%;
      }
    `}</style>

      <main id="primary" className="site-main">
        <div className="space-for-header"></div>

        {/* Breadcrumb Section */}
        <section
          className="tj-page-header section-gap-x"
          data-bg-image="assets/images/bg/pheader-bg.webp"
        >
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div className="tj-page-header-content text-center">
                  <h1 className="tj-page-title">Multi Mill Machine</h1>
                  <div className="tj-page-link">
                    <span><i className="fa-solid fa-home"></i></span>
                    <span><a href="/">Home</a></span>
                    <span><i className="fa-solid fa-arrow-right"></i></span>
                    <span><span>Multi Mill Machine</span></span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div 
            className="page-header-overlay"
            data-bg-image="assets/images/shape/pheader-overlay.png"
          ></div>
        </section>

        {/* MAIN CONTENT SECTION */}
        <section className="tj-blog-section section-gap slidebar-stickiy-container">
          <div className="container">
            <div className="row row-gap-5">

              {/* LEFT CONTENT */}
              <div className="col-lg-8">
                <div className="post-details-wrapper">

                  {/* MAIN IMAGE CENTERED */}
                  <div
                    className="blog-images wow fadeInUp"
                    data-wow-delay=".1s"
                    style={{ display: "flex", justifyContent: "center" }}
                  >
                    <div className="col-sm-6">
                      <img 
                        src="assets/images/SD_PHRMA_ALL_MIX _JPGS/33.png"
                        alt="Multi Mill Machine"
                      />
                    </div>
                  </div>

                  <h2 className="title title-anim">Multi Mill Machine</h2>

                  {/* DESCRIPTION */}
                  <div className="blog-text">
                    <p className="wow fadeInUp" data-wow-delay=".3s">
                      The Multi Mill Machine is used for high-speed granulating, 
                      pulverizing, mixing, shredding, and chopping of a wide range 
                      of materials in pharmaceutical, chemical, and food industries.
                    </p>

                    <p className="wow fadeInUp" data-wow-delay=".4s">
                      Its beaters operate in multiple directions and at variable 
                      speed, ensuring controlled particle size with minimal heat 
                      generation. The machine features stainless steel contact 
                      parts and tool-free dismantling for easy cleaning.
                    </p>
                  </div>

                  {/* EXTRA IMAGES */}
                  <div className="images-wrap">
                    <div className="row">
                      
                      <div className="col-sm-6">
                        <div className="image-box wow fadeInUp" data-wow-delay=".3s">
                          <img 
                            src="assets/images/SD_PHRMA_ALL_MIX _JPGS/33.png"
                            alt="Multi Mill Side View"
                          />
                        </div>
                      </div>

                      <div className="col-sm-6">
                        <div className="image-box wow fadeInUp" data-wow-delay=".5s">
                          <img 
                            src="assets/images/SD_PHRMA_ALL_MIX _JPGS/34.png"
                            alt="Multi Mill Closeup"
                          />
                        </div>
                      </div>

                    </div>
                  </div>

                  {/* TECHNICAL SPECIFICATIONS */}
                  <div className="technical-spec-section">
                    <h4>Technical Specification</h4>

                    <table className="table table-bordered">
                      <tbody>

                        <tr>
                          <td>Model</td>
                          <td>DPM-MM-1</td>
                          <td>DPM-MM-2</td>
                          <td>DPM-MM-3</td>
                        </tr>

                        <tr>
                          <td>Output Capacity</td>
                          <td>30–100 kg/hr</td>
                          <td>100–250 kg/hr</td>
                          <td>250–500 kg/hr</td>
                        </tr>

                        <tr>
                          <td>Rotor Speed</td>
                          <td>750–3000 RPM</td>
                          <td>750–3000 RPM</td>
                          <td>750–3000 RPM</td>
                        </tr>

                        <tr>
                          <td>Motor Power</td>
                          <td>1 HP</td>
                          <td>2 HP</td>
                          <td>3 HP</td>
                        </tr>

                        <tr>
                          <td>Screen Diameter</td>
                          <td>250 mm</td>
                          <td>300 mm</td>
                          <td>350 mm</td>
                        </tr>

                        <tr>
                          <td>Beater Type</td>
                          <td colSpan="3">Multi-Directional Beaters</td>
                        </tr>

                        <tr>
                          <td>Material Construction</td>
                          <td colSpan="3">SS 304 / SS 316 Contact Parts</td>
                        </tr>

                        <tr>
                          <td>Machine Dimensions (L × W × H)</td>
                          <td>600 × 450 × 1200 mm</td>
                          <td>700 × 500 × 1300 mm</td>
                          <td>850 × 600 × 1400 mm</td>
                        </tr>

                        <tr>
                          <td>Machine Weight</td>
                          <td>120 kg</td>
                          <td>160 kg</td>
                          <td>210 kg</td>
                        </tr>

                      </tbody>
                    </table>

                  </div>

                </div>
              </div>

              {/* RIGHT SIDEBAR */}
              <div className="col-lg-4 sidebar-container">
                <div className="tj-main-sidebar">

                  <div className="tj-sidebar-widget service-categories">
                    <h4 className="widget-title">Related Products</h4>

                    <ul>

                      <li>
                        <a href="/vibro-sifter">
                          Vibro Sifter Machine
                          <span className="icon"><i className="fa-solid fa-arrow-right" /></span>
                        </a>
                      </li>

                      <li>
                        <a href="/oscillating-granulator">
                          Oscillating Granulator
                          <span className="icon"><i className="fa-solid fa-arrow-right" /></span>
                        </a>
                      </li>

                      <li>
                        <a href="/mass-mixer">
                          Mass Mixer Machine
                          <span className="icon"><i className="fa-solid fa-arrow-right" /></span>
                        </a>
                      </li>

                    </ul>

                  </div>

                </div>
              </div>

            </div>
          </div>
        </section>
      </main>
    </>
  );
}

export default MultiMillMachine;
